const CN = {
    homePage:'首页',
    productPage:'产品',
    scenePage:'应用',
    videoPage:'视频',
    aboutPage:'关于我们',
    contactPage:'联系我们',
    supportPage:'支持',
    download:'下载',
    videoGallery:{
        title1:'1.6km变倍',
        title2:'飞行状态下长焦实拍画面效果',
        title3:'KCF追踪',
        title4:'SCP4大疆版遥控器录屏',
        description1:'目标物 1.6km，长焦变倍及数字变倍效果',
        description2:'平飞及下视90°画面稳定无水波纹',
        description3:'在无AI训练情况下，对非特定目标物框选追踪实拍',
        description4:'长焦/广角/红外任意分屏演示'
    },
    industryApplications:'行业应用',
    applicationPage:{
        title1:'交通交管，边防海防',
        description1:'在情报侦察应用场景中，可利用四光多传感器的优势，一次任务调动高倍率、远距离先进光学传感器（可见光、热成像镜头和高精度激光测距模块）协同作业，对目标可实行快速搜寻、位置获取、数量统计、持续跟踪和战场毁伤评估的功能运用方式，为指战员提供隐蔽精准的战场态势情报。构建智能监测预警机制，可及时发现并识别潜在威胁。通过吊舱的高空视角，可弥补地面巡逻的盲区，大幅提升日常巡逻的工作效率与质量。从而有效保证边境、海域安全的稳固。',
        title2:'服务机器人巡检（能源监测、安防、测绘）',
        description2:'利用多传感器多视角及AI识别技术，推动变电站，输配电一体的空地一体化电力自动巡检系统。帮助能源行业向全自主巡检发展',
        title3:'智慧城市立体防控',
        description3:'一次飞行任务即可利用多传感器多视角赋能城市多职能业务部门，如交通，消防，城管等。实现全天候无人值守一体化智慧城市低空巡检。',
        title4:'智能制造',
        description4:'智能制造设备能够获取高分辨率的图像信息，并在设备端自带的算力完成图像处理、分析和理解等多个环节，使得智能影响设备广泛应用于工业自动化、医疗影像分析、智能交通系统、机器人导航等领域。'
    },
    technicalParameter:'技术参数',
    downLoadDetail:'下载详情',
    videoGalleryTips:'视频画廊',
    downLoadList:'下载列表',
    serviceEmail:'服务邮箱',
    businessContacts:'商务对接',
    technicalContacts:'技术对接',
    companyAddress:'公司地址(香港)',
    company_intro_title:'公司介绍',
    company_intro_des:'布雷斯塔基于图像识别技术的实现逻辑和行业基础设施的空缺，从 计算机视觉的基础设备开始布局，针对使用场景开发多传感器融合的AI智 能视觉系统为行业应用提供设备和服务。布雷斯塔创始团队来自于华为、中兴、腾讯，团队有丰富的产品研发、芯片应用和开发、高性能云计算、并行计算、人工智能等领域项目经验。'

}

module.exports = CN
